module.exports = __webpack_public_path__ + "img/1525223230.be99447d.jpg";